import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogArticles } from '../data/mockData';
import { ArrowLeft, Clock, Calendar } from 'lucide-react';

const BlogPost = () => {
  const { slug } = useParams();
  const article = blogArticles.find(a => a.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Article Not Found</h1>
          <Link to="/" className="text-[#6366F1] hover:text-[#4F46E5] font-medium text-sm">Back to Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Image */}
      <div className="w-full h-[360px] md:h-[420px] relative overflow-hidden bg-[#1E1B4B]">
        <img src={article.image} alt={article.title} className="w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1E1B4B] via-[#1E1B4B]/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 lg:px-8 -mt-24 relative z-10">
        <div className="bg-white rounded-2xl shadow-[0_8px_40px_rgba(99,102,241,0.08)] border border-[#EDE9FE] p-8 md:p-12">
          <Link to="/#blog" className="inline-flex items-center gap-2 text-sm text-[#6366F1] hover:text-[#4F46E5] mb-6 transition-colors font-medium">
            <ArrowLeft className="w-4 h-4" /> Back to Insights
          </Link>

          <div className="flex items-center gap-3 mb-4">
            <span className="pill-badge bg-[#EDE9FE] text-[#6366F1] text-[11px]">{article.category}</span>
            <div className="flex items-center gap-1.5 text-xs text-[#6B7280]">
              <Calendar className="w-3.5 h-3.5" /> {article.date}
            </div>
            <div className="flex items-center gap-1.5 text-xs text-[#6B7280]">
              <Clock className="w-3.5 h-3.5" /> {article.readTime}
            </div>
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-[#1E1B4B] mb-8 leading-tight" style={{ fontFamily: "'Playfair Display',serif" }}>
            {article.title}
          </h1>

          <div className="space-y-5">
            {article.content.map((para, i) => (
              <p key={i} className="text-base font-normal text-[#4B5563] leading-relaxed">
                {para}
              </p>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-[#EDE9FE]">
            <p className="text-sm text-[#6B7280] mb-4">Ready to protect your brand?</p>
            <Link to="/" className="inline-flex items-center gap-2 btn-gradient text-white font-semibold px-6 py-3 text-sm rounded-full">
              Get Started Today <ArrowLeft className="w-4 h-4 rotate-180" />
            </Link>
          </div>
        </div>
      </div>

      {/* Spacer */}
      <div className="h-20" />
    </div>
  );
};

export default BlogPost;
